import React from "react";
import "./messageFromCeo.css";
import ceoImage from "../../assets/message-from-soori.jpg";
import AutoTyping, { BlinkCursor } from "react-auto-typing";
import { Link } from "react-router-dom";

const MessageFromCeo = () => {
  const scrollHeader = () => {
    window.scroll({ top: 0, behavior: "instant" });
  };
  return (
    <>
      <div className="message-from-ceo-wrapper">
        <div className="section-title">
          <h1 className="title">Message From Soori Corporation</h1>
          <span className="subtitle" aria-hidden="true">
            <AutoTyping
              active // <boolean>
              textRef={"Messages"}
              writeSpeed={150} // <number>
              deleteSpeed={150} // <number>
              delayToWrite={1000} // <number>
              delayToDelete={2000}
            />
          </span>
        </div>
        <div className="message-from-ceo-details-container mb-5">
          <div class="row">
            <div class="col-12 col-lg-5">
              <div className="image-container">
                <img alt="image" src={ceoImage} />
              </div>
            </div>
            <div class="col-12 offset-0 col-lg-6 offset-lg-1 ">
              <div className="message-from-ceo-details ">
                At Soori Corporation, we are committed to empowering businesses
                through innovative software solutions that drive growth and
                efficiency. Our team of experts is dedicated to transforming
                different industries by leveraging cutting-edge technology to
                create impactful results.
                <br /> <br />
                We take pride in delivering high-quality, scalable digital
                products that truly resonate with our clients' needs. With a
                focus on collaboration and excellence, our talented developers
                ensure our solutions align seamlessly with your goals, fostering
                sustainable success. We are committed to staying at the
                forefront of technology and providing exceptional value. hnology
                and delivering exceptional value is what sets us apart.
              </div>
              <br />
              <Link
                to="/contact-us"
                class="connect-link transition mt-4"
                tabindex="-1"
                onClick={scrollHeader}
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MessageFromCeo;
